import type { ReactNode } from "react";
import type { IconComponent } from "../../ui/icon";
type Props = {
  icon?: IconComponent;
  title: string;
  text?: string;
  action?: ReactNode;
  className?: string;
};

/** Eén lege toestand voor elke lijst in het beheer: wat er is, en wat je nu kunt doen. */
export function EmptyState({
  icon: Icon,
  title,
  text,
  action,
  className = ''
}: Props) {
  return <div className={`rounded-lg border border-dashed border-line bg-white/60 px-6 py-12 text-center ${className}`} data-id="element-5027" data-mp="18hd0sq8412ya">
      {Icon && <span className="mx-auto mb-3 flex h-10 w-10 items-center justify-center rounded-full bg-sand text-muted" aria-hidden="true" data-id="element-5028" data-mp="13ia2dommxuza">
          <Icon className="h-5 w-5" strokeWidth={1.5} data-id="element-5029" data-mp="yhm6aojjuny7" />
        </span>}
      <p className="text-[15px] text-ink" data-id="element-5030" data-mp="tjcacbq03jbj">{title}</p>
      {text && <p className="mx-auto mt-1 max-w-sm text-[13px] leading-relaxed text-muted" data-id="element-5031" data-mp="3j9o6lop7z28p">{text}</p>}
      {action && <div className="mt-4 flex justify-center" data-id="element-5032" data-mp="3eauv21thtlb6">{action}</div>}
    </div>;
}